import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56ac43ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "refresh-window"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (_ctx.needsRefresh)
        ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("There is")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("new content")), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("available")) + ". ", 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "focus",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
              }, _toDisplayString(_ctx.$t("Reload")), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, _toDisplayString(_ctx.$t("Close")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}